import { Button, notification, Popover, Spin } from "antd";
import React, { useState } from "react";
import BinApiService from "src/api/BinApiService";
import PremierPlusBinDTO from "src/models/PremierPlusBinDTO";
import NoticeCard from "./NoticeCard";
import StopConfirmationContent from "./StopConfirmationContent";

interface FanOperationsCardProps{
    binDto: PremierPlusBinDTO | null;
    handleShowFanSettingsModal: () => void;
    handleClickViewFan: () => void;
}

const FanOperationsCard : React.FC<FanOperationsCardProps> = ({ binDto, handleShowFanSettingsModal, handleClickViewFan }) => {
    const [fanPopoverOpen, setFanPopoverOpen] = useState(false);
    const [isSpinning, setIsSpinning] = useState(false);
    
    const onClickYesStopFans = async () => {
        try{
            setIsSpinning(true);
            const result = await BinApiService.premierPlus_StopFanOperation(binDto?.binId ?? 0);
            notification.success({ message: 'Fans stopped successfully'});
        }catch(err){
            console.error('Error stopping fans:', err);
            notification.error({ message: 'Error stopping fans', description: 'Please try again later.' });
        }finally{
            setIsSpinning(false);
        }

        setFanPopoverOpen(false);
    }

    const onClickNoStopFans = () => {
      setFanPopoverOpen(false)
    }

    return(
        <NoticeCard
        title="Run fans is active"
        description="Automated fan operations are currently active"
        buttons={
            <>
                <Popover
                    open={fanPopoverOpen}
                    trigger="click"
                    onOpenChange={(newOpen) => {
                    if (!newOpen) setFanPopoverOpen(false);
                    }}
                    content={
                        <Spin spinning={isSpinning}>
                            <StopConfirmationContent
                                message="Are you sure you want to stop all fans?"
                                onConfirm={onClickYesStopFans}
                                onCancel={onClickNoStopFans}
                            />
                        </Spin>
                    }
                >
                    <Button type="primary" danger onClick={() => setFanPopoverOpen(true)}>
                    Stop All Fans
                    </Button>
                </Popover>

                <Button type="primary" onClick={handleShowFanSettingsModal}>
                    Adjust Settings
                </Button>
                
                <Button type="primary" onClick={handleClickViewFan}>
                    View HMI 
                </Button>
            </>
        }
        />
    )   
}

export default FanOperationsCard;